import {forOwn, isEmpty, isObject, keys} from 'lodash';
import {useEffect, useState} from 'react';
import {useStore} from 'react-redux';

import {LIBRARY_NAME} from 'src/js/common/constants';
import LogUtils from 'src/js/common/utils/log_utils';

const logger = LogUtils.getLogger('useReducers', LIBRARY_NAME);

export interface UseReducersReturnValue {
  reducersInitialized: boolean;
}

export function useReducers(
  reducers: Record<string, any>
): UseReducersReturnValue {
  const store = useStore();
  const [reducersInitialized, setReducersInitialized] = useState(false);

  useEffect(() => {
    if (
      store &&
      store.injectReducer &&
      !isEmpty(reducers) &&
      isObject(reducers)
    ) {
      forOwn(reducers, (reducer, key) => {
        store.injectReducer(key, reducer);
      });
    } else {
      const reducerKeys =
        !isEmpty(reducers) && isObject(reducers) ? keys(reducers) : '';
      logger.warn(
        `Redux store injectReducer is not defined. Reducers "${reducerKeys}" were not added`
      );
    }
    setReducersInitialized(true);
  }, [store, reducers]);

  return {reducersInitialized};
}
